import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type GovernmentIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M8 4.00004V1.33337',
    'M1.3335 14.6666H14.6668',
    'M1.3335 8H14.6668',
    'M10 8L10 14.6667',
    'M6 8L6 14.6667',
    'M11.6 8C11.8209 8 12.0021 7.8204 11.9803 7.60056C11.7799 5.57897 10.0744 4 8 4C5.92563 4 4.22012 5.57897 4.01969 7.60056C3.9979 7.8204 4.17909 8 4.4 8H11.6Z',
  ],
  '24': [
    'M11 5V1',
    'M1 21H21',
    'M1 11H21',
    'M14 11L14 21',
    'M8 11L8 21',
    'M16.4 11C16.7314 11 17.0032 10.7306 16.9705 10.4008C16.6698 7.36845 14.1116 5 11 5C7.88845 5 5.33018 7.36845 5.02954 10.4008C4.99685 10.7306 5.26863 11 5.6 11H16.4Z',
  ],
  '32': [
    'M15 7.00008V1.66675',
    'M1.6665 28.3334H28.3332',
    'M1.6665 15.0001H28.3332',
    'M19 15.0001L19 28.3334',
    'M11 15.0001L11 28.3334',
    'M22.2 15.0001C22.6418 15.0001 23.0042 14.6409 22.9606 14.2012C22.5598 10.158 19.1487 7.00006 15 7.00006C10.8513 7.00006 7.44024 10.158 7.03939 14.2012C6.9958 14.6409 7.35817 15.0001 7.8 15.0001H22.2Z',
  ],
};

const rectX = {
  '32': '4.3335',
  '24': '3',
  '16': '2.6665',
};

const rectY = {
  '32': '15.0001',
  '24': '11',
  '16': '8',
};

const rectWidth = {
  '32': '21.3333',
  '24': '16',
  '16': '10.6667',
};

const rectHeight = {
  '32': '13.3333',
  '24': '10',
  '16': '6.66667',
};

const rectRX = {
  '32': '1.33333',
  '24': '1',
  '16': '0.666667',
};

<rect
  x="2.6665"
  y="8"
  width="10.6667"
  height="6.66667"
  rx="0.666667"
  stroke="#1E1E20"
  strokeWidth="1.33333"
/>;
<rect
  x="3"
  y="11"
  width="16"
  height="10"
  rx="1"
  stroke="#1E1E20"
  strokeWidth="2"
/>;
<rect
  x="4.3335"
  y="15.0001"
  width="21.3333"
  height="13.3333"
  rx="1.33333"
  stroke="#1E1E20"
  strokeWidth="2.66667"
/>;

const GovernmentIcon = ({id, className, size, color}: GovernmentIconProps) => {
  const strokeWidth = iconStrokeWidthBySize[size];
  const pathDs = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      fill="none"
      viewBox={`0 0 ${size === '16' ? '16' : parseInt(size) - 2} ${
        size === '16' ? '16' : parseInt(size) - 2
      }`}
      width={size === '16' ? '16' : parseInt(size) - 2}
      height={size === '16' ? '16' : parseInt(size) - 2}>
      {pathDs.map((d, i) => (
        <path
          key={i}
          d={d}
          stroke={colorOptions}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
      <rect
        x={rectX[size]}
        y={rectY[size]}
        width={rectWidth[size]}
        height={rectHeight[size]}
        rx={rectRX[size]}
        stroke={colorOptions}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default GovernmentIcon;
